import localForage from "localforage";
export default (function () {
    var alertBanner = document.querySelector(".alert-banner");
    if (alertBanner) {
        localForage
            .getItem("banner-expiry")
            .then(function (value) {
            if (value < Date.now()) {
                alertBanner.removeAttribute("hidden");
            }
            else {
                alertBanner.setAttribute("hidden", "true");
            }
        })
            .catch(function (err) {
            console.error(err);
        });
        var closeButton = alertBanner.querySelector("button.alert-banner--close");
        if (closeButton) {
            closeButton.addEventListener("click", dismissBanner);
        }
    }
    function dismissBanner() {
        var expiry = Date.now() + 1 * 86400000;
        localForage
            .setItem("banner-expiry", expiry)
            .then(function (value) {
            if (alertBanner) {
                alertBanner.setAttribute("hidden", "true");
            }
        })
            .catch(function (err) {
            console.log(err);
        });
    }
});
